import {
  CalendarToday as CalendarTodayIcon,
  FileDownload as FileDownloadIcon,
} from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import { CSVLink } from 'react-csv';
import { ViewOnlyAlert } from 'src/components/viewOnlyAlert';
import { lang, useUserRole } from 'src/utils';

import { useActionBar } from './ActionBar.hook';
import { ActionBarProps } from './ActionBar.interface';
import { Wrapper } from './ActionBar.styled';

export const ActionBar = (props: ActionBarProps) => {
  const { csvData } = useActionBar(props.sortTableData, props.headers);
  const { isViewOnly } = useUserRole();

  const handleExportClick = () => {
    if (!props.sortTableData || props.sortTableData.length === 0) {
      return;
    }
  };

  return (
    <Wrapper>
      <Stack direction="row" spacing={2}>
        <CSVLink
          data={csvData}
          headers={props.headers}
          filename="Location_Group.csv"
          target="_blank"
          style={{ textDecoration: 'none' }}>
          <Button
            style={{ display: 'none' }} // temporary fix for hiding the button
            variant="outlined"
            startIcon={<FileDownloadIcon />}
            onClick={handleExportClick}>
            {lang.export}
          </Button>
        </CSVLink>

        {isViewOnly ? (
          <ViewOnlyAlert />
        ) : (
          <>
            {props.showScheduler && props.isLocationGroupSchedule && (
              <Button
                variant="outlined"
                startIcon={<CalendarTodayIcon />}
                onClick={props.onSchedulerHandleClick}>
                {props?.label || lang.scheduler}
              </Button>
            )}
          </>
        )}
      </Stack>
    </Wrapper>
  );
};
